/**
 * Admin Panel page — tabbed shell matching Ads Manager / Offers:
 * tabs live in the top navbar next to the burger; content fills below.
 */

import { useMemo } from "react"
import { NavLink, Outlet } from "react-router"

import { NavbarTabList, navbarTabClass } from "@/components/NavbarTabs"
import { useNavbarLeftAction, usePageTitle } from "@/layouts/pageChrome"

const TABS = [
  { to: "/admin/users", label: "Users", end: true },
  { to: "/admin/accounts", label: "Ad Accounts", end: false },
  { to: "/admin/domains", label: "Domains", end: false },
  { to: "/admin/pixels", label: "Pixels", end: false },
  { to: "/admin/ad-networks", label: "Ad Networks", end: false },
] as const

export default function AdminPanelPage() {
  usePageTitle("", "Admin Panel")

  const navbarTabs = useMemo(
    () => (
      <NavbarTabList>
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) => navbarTabClass(isActive)}
          >
            {tab.label}
          </NavLink>
        ))}
      </NavbarTabList>
    ),
    [],
  )
  useNavbarLeftAction(navbarTabs)

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden bg-[#3a3a3a]">
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-1.5 pt-1.5 sm:px-2 sm:pt-2">
        <Outlet />
      </div>
    </div>
  )
}
